import { useEffect, useState } from 'react';
import Card from '../components/Card';
import { crmService } from '../services/crmService';
import type { Empresa, Pessoa } from '../types';

const isEmpresa = (item: Empresa | Pessoa): item is Empresa => 'nome_empresa' in item;

export default function AbertosPage() {
  const [items, setItems] = useState<Array<Empresa | Pessoa>>([]);

  useEffect(() => {
    crmService.getAbertos().then(setItems);
  }, []);

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-black">Itens Abertos</h1>
      <div className="grid gap-3 md:grid-cols-2">
        {items.length === 0 ? <Card>Nenhuma pendência em aberto.</Card> : null}
        {items.map((item) => (
          <Card key={item.id}>
            {isEmpresa(item) ? (
              <>
                <p className="font-semibold">{item.nome_empresa}</p>
                <p className="text-sm text-slate-500">Empresa · Status: {item.status_kanban}</p>
                <p className="text-xs text-slate-500">{item.telefone}</p>
              </>
            ) : (
              <>
                <p className="font-semibold">{item.nome}</p>
                <p className="text-sm text-slate-500">Pessoa · {item.cargo}</p>
                <p className="text-xs text-slate-500">Email: {item.status_email ? 'ok' : 'pendente'} · Telefone: {item.status_telefone ? 'ok' : 'pendente'}</p>
              </>
            )}
          </Card>
        ))}
      </div>
    </div>
  );
}

